import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=64973d01&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports